import { persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export const CUSTOMER_DISCOVERY_STATUS = {
  IDLE: 'idle',
  LOADING: 'loading',
  READY: 'ready',
  ERROR: 'error',
}

const actionTypes = {
  SetCustomers: 'customers/SET_CUSTOMERS',
  InvalidateCustomers: 'customers/INVALIDATE_CUSTOMERS',
  SetCustomerDiscoveryStatus: 'customers/SET_CUSTOMER_DISCOVERY_STATUS',
  CompleteCustomerDiscovery: 'customers/COMPLETE_CUSTOMER_DISCOVERY',
  SetSelectedCustomer: 'customers/SET_SELECTED_CUSTOMER',
  SetNewSyncingCustomer: 'customers/SET_NEW_SYNCING_CUSTOMER',
  RemoveSyncingCustomer: 'customers/REMOVE_SYNCING_CUSTOMER',
  SetIntegrationRefreshCustomer: 'customers/SET_INTEGRATION_REFRESH_CUSTOMER',
  ClearIntegrationRefreshCustomer: 'customers/CLEAR_INTEGRATION_REFRESH_CUSTOMER',
}

const initialState = {
  data: [],
  discoveryStatus: CUSTOMER_DISCOVERY_STATUS.IDLE,
  discoveryGeneration: 0,
  syncing: [],
  integrationRefreshCustomerId: null,
  integrationRefreshPollId: null,
  selectedCustomer: undefined,
}

const customersReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SetCustomers:
      return { ...state, data: action.payload.customers }
    case actionTypes.InvalidateCustomers:
      return {
        ...state,
        data: [],
        discoveryStatus: CUSTOMER_DISCOVERY_STATUS.IDLE,
        discoveryGeneration: state.discoveryGeneration + 1,
      }
    case actionTypes.SetCustomerDiscoveryStatus:
      if (
        action.payload.discoveryGeneration != null &&
        action.payload.discoveryGeneration !== state.discoveryGeneration
      ) {
        return state
      }
      return { ...state, discoveryStatus: action.payload.discoveryStatus }
    case actionTypes.CompleteCustomerDiscovery: {
      const { discoveryGeneration, customers, defaultSelectedCustomer } = action.payload
      if (discoveryGeneration !== state.discoveryGeneration) return state
      return {
        ...state,
        data: customers,
        discoveryStatus: CUSTOMER_DISCOVERY_STATUS.READY,
        selectedCustomer:
          !state.selectedCustomer && defaultSelectedCustomer ? defaultSelectedCustomer : state.selectedCustomer,
      }
    }
    case actionTypes.SetSelectedCustomer:
      return { ...state, selectedCustomer: action.payload.selectedCustomer }
    case actionTypes.SetNewSyncingCustomer: {
      const { customerId } = action.payload
      if (customerId == null || state.syncing.includes(customerId)) return state
      return {
        ...state,
        syncing: [...state.syncing, customerId],
      }
    }
    case actionTypes.RemoveSyncingCustomer:
      return {
        ...state,
        syncing: state.syncing.filter((id) => id !== action.payload.customerId),
      }
    case actionTypes.SetIntegrationRefreshCustomer: {
      const { customerId, pollId } = action.payload
      if (customerId == null || pollId == null) return state
      if (state.integrationRefreshCustomerId === customerId && state.integrationRefreshPollId === pollId) return state
      return { ...state, integrationRefreshCustomerId: customerId, integrationRefreshPollId: pollId }
    }
    case actionTypes.ClearIntegrationRefreshCustomer: {
      const { customerId, pollId } = action.payload
      if (state.integrationRefreshPollId == null) return state
      if (state.integrationRefreshCustomerId !== customerId || state.integrationRefreshPollId !== pollId) return state
      return { ...state, integrationRefreshCustomerId: null, integrationRefreshPollId: null }
    }
    default:
      return state
  }
}

export const reducer = persistReducer(
  {
    storage,
    key: 'customers',
    blacklist: [
      'discoveryStatus',
      'discoveryGeneration',
      'syncing',
      'integrationRefreshCustomerId',
      'integrationRefreshPollId',
    ],
  },
  customersReducer,
)

export const actions = {
  setCustomers: (customers) => ({
    type: actionTypes.SetCustomers,
    payload: { customers },
  }),
  invalidateCustomers: () => ({
    type: actionTypes.InvalidateCustomers,
  }),
  setCustomerDiscoveryStatus: (discoveryStatus, discoveryGeneration) => ({
    type: actionTypes.SetCustomerDiscoveryStatus,
    payload: { discoveryStatus, discoveryGeneration },
  }),
  completeCustomerDiscovery: ({ customers, discoveryGeneration, defaultSelectedCustomer }) => ({
    type: actionTypes.CompleteCustomerDiscovery,
    payload: { customers, discoveryGeneration, defaultSelectedCustomer },
  }),
  setSelectedCustomer: (selectedCustomer) => ({
    type: actionTypes.SetSelectedCustomer,
    payload: { selectedCustomer },
  }),
  setNewSyncingCustomer: (customerId) => ({
    type: actionTypes.SetNewSyncingCustomer,
    payload: { customerId },
  }),
  removeSyncingCustomer: (customerId) => ({
    type: actionTypes.RemoveSyncingCustomer,
    payload: { customerId },
  }),
  setIntegrationRefreshCustomer: (customerId, pollId) => ({
    type: actionTypes.SetIntegrationRefreshCustomer,
    payload: { customerId, pollId },
  }),
  clearIntegrationRefreshCustomer: (customerId, pollId) => ({
    type: actionTypes.ClearIntegrationRefreshCustomer,
    payload: { customerId, pollId },
  }),
}
